import axios from "axios";

export const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const api = axios.create({ baseURL: `${BACKEND}/api`, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("c4x4_admin_token");
  if (token && config.url?.startsWith("/admin")) config.headers.Authorization = `Bearer ${token}`;
  if (token && config.url?.startsWith("/auth")) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const imgUrl = (src) => (src?.startsWith("/api/") ? `${BACKEND}${src}` : src || "");

export const gbp = (n) =>
  n == null ? "POA" : new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(n);

export const miles = (n) => (n == null ? "—" : `${Number(n).toLocaleString("en-GB")} miles`);

export const vehicleTitle = (v) => `${v?.year ?? ""} ${v?.make ?? ""} ${v?.model ?? ""}`.trim();

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x?.msg || "").replace("Value error, ", "")).join(" ");
  return String(d);
}

export async function downloadFile(url, name) {
  const { data } = await api.get(url, { responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(data);
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(a.href);
}


export const STATUS_LABELS = {
  just_arrived: "Just arrived",
  reserved: "Reserved",
  coming_soon: "Arriving soon",
  sold: "Sold",
  available: "",
  draft: "Draft",
};
